import { createSlice } from '@reduxjs/toolkit';
import type { CommentsState } from './types';

const slice = createSlice({
  name: 'comments',
  initialState: {
    ready: false,
    connection: undefined,
    channels: undefined,
    currentChannel: undefined,
    comments: {},
    panel: {},
  } as CommentsState,
  reducers: {
    setReady: (state, action) => {
      state.ready = action.payload;
    },
    setChannels: (state, action) => {
      state.channels = action.payload;
    },
    setCurrentChannel: (state, action) => {
      state.currentChannel = action.payload;
    },
    setComments: (state, action) => {
      state.comments = action.payload;
    },
    setPanel: (state, action) => {
      state.panel = action.payload;
    },
    setPanelView: (state, action) => {
      state.panel.view = action.payload;
    },
    reset: (state) => {
      state.ready = false;
      state.channels = undefined;
      state.currentChannel = undefined;
      state.comments = {};
    },
  },
});

export const commentsActions = slice.actions;
export const commentsReducer = slice.reducer;
